import React, { useState , useEffect } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import "./Sidebar.css";
import homeIcon from '../../Assets/img/home.svg';
import aboutIcon from '../../Assets/img/personalcard.svg';
import servicesIcon from '../../Assets/img/task.svg';
import contactIcon from '../../Assets/img/call-calling.svg';
import faqIcon from '../../Assets/img/message-question.svg';
import newsIcon from '../../Assets/img/chart.svg';
import blogIcon from '../../Assets/img/clipboard-text.svg';
import eligibilityIcon from '../../Assets/img/tick-circle.svg';
import consultationIcon from '../../Assets/img/menu-board.svg';
import settingIcon from '../../Assets/img/setting.svg';
import UserIcon from '../../Assets/img/user.png';
import { FaChevronDown, FaChevronRight } from "react-icons/fa";

let sidebarOpen = true;
let listeners = [];

const setSidebarOpen = (value) => {
    sidebarOpen = typeof value === "function" ? value(sidebarOpen) : value;
    listeners.forEach((listener) => listener(sidebarOpen));
};

export const useSidebarToggle = () => {
    const [isOpen, setIsOpen] = useState(sidebarOpen);

    useEffect(() => {
        listeners.push(setIsOpen);
        return () => {
            listeners = listeners.filter((listener) => listener !== setIsOpen);
        };
    }, []);

    const toggleSidebar = () => setSidebarOpen((prev) => !prev);
    const closeSidebar = () => setSidebarOpen(false);

    return { isOpen, toggleSidebar, closeSidebar };
};

const Sidebar = () => {
    const navigate = useNavigate();
    const location = useLocation();
    const { isOpen, closeSidebar } = useSidebarToggle();
    const [faqOpen, setFaqOpen] = useState(false);
    const [blogOpen, setBlogOpen] = useState(false);
    const [newsOpen, setNewsOpen] = useState(false);
    const [oldconsultationOpen, setOldConsultationOpen] = useState(false);
    const [consultationOpen, setConsultationOpen] = useState(false);
    const [eligibilityOpen, setEligibilityOpen] = useState(false);

    const startsWith = (path) => location.pathname.startsWith(path);

    // 🔑 clear consultation session ONLY when leaving consultation
    const handleTabChange = (path) => {
        sessionStorage.removeItem("consultationLanguageId");
        navigate(path);
    };

    return (
        <div className={`sidebar-a ${isOpen ? "sidebar-open" : "sidebar-closed"}`}>
            {isOpen && <div className="sidebar-overlay" onClick={closeSidebar} />}
            <aside>
                <div className="sidebar">
                    <nav className="sidebar-nav">
                        <div className="nav-main">
                            <ul className="nav flex-column sidebar-nav">

                                {/* Admin */}
                                <li>
                                    <button
                                        onClick={() => handleTabChange('/admin')}
                                        className={startsWith('/admin') ? 'active' : ''}
                                    >
                                        <img src={UserIcon} alt="Admin" className="sidebar-icon" />
                                        Admin
                                    </button>
                                </li>

                                {/* FAQ */}
                                <li>
                                    <button
                                        onClick={() => {
                                            sessionStorage.removeItem("consultationLanguageId");
                                            setFaqOpen(prev => !prev);
                                        }}
                                        className={`faq-main-btn ${startsWith('/faq') || startsWith('/category') ? 'active' : ''}`}
                                    >
                                        <img src={faqIcon} alt="FAQ" className="sidebar-icon" />
                                        FAQ
                                        {faqOpen ? (
                                            <FaChevronDown className="faq-arrow" />
                                        ) : (
                                            <FaChevronRight className="faq-arrow" />
                                        )}
                                    </button>

                                    {faqOpen && (
                                        <ul className="faq-submenu">
                                            <li>
                                                <button onClick={() => handleTabChange('/faq')}
                                                    className={startsWith('/faq') ? 'active' : ''}>
                                                    FAQ List
                                                </button>
                                            </li>
                                            <li>
                                                <button onClick={() => handleTabChange('/category')}
                                                    className={startsWith('/category') ? 'active' : ''}>
                                                    Category
                                                </button>
                                            </li>
                                        </ul>
                                    )}
                                </li>

                                {/* News */}
                                <li>
                                    <button
                                        onClick={() => {
                                            sessionStorage.removeItem("consultationLanguageId");
                                            setNewsOpen(prev => !prev);
                                        }}
                                        className={`faq-main-btn ${startsWith('/news') || startsWith('/newscategory') ? 'active' : ''}`}
                                    >
                                        <img src={newsIcon} alt="News" className="sidebar-icon" />
                                        News
                                        {newsOpen ? (
                                            <FaChevronDown className="faq-arrow" />
                                        ) : (
                                            <FaChevronRight className="faq-arrow" />
                                        )}
                                    </button>

                                    {newsOpen && (
                                        <ul className="faq-submenu">
                                            <li>
                                                <button onClick={() => handleTabChange('/news')}
                                                    className={startsWith('/news') && !startsWith('/newscategory') ? 'active' : ''}>
                                                    News List
                                                </button>
                                            </li>

                                            {/* ✅ News Category */}
                                            <li>
                                                <button onClick={() => handleTabChange('/newscategory')}
                                                    className={startsWith('/newscategory') ? 'active' : ''}>
                                                    News Category
                                                </button>
                                            </li>
                                        </ul>
                                    )}
                                </li>

                                {/* Blog */}
                                <li>
                                    <button
                                        onClick={() => {
                                            sessionStorage.removeItem("consultationLanguageId");
                                            setBlogOpen(prev => !prev);
                                        }}
                                        className={`faq-main-btn ${location.pathname.startsWith('/blog') ||
                                            location.pathname.startsWith('/blogtag')
                                            ? 'active'
                                            : ''
                                            }`}
                                    >
                                        <img src={blogIcon} alt="Blog" className="sidebar-icon" />
                                        Blog
                                        {blogOpen ? (
                                            <FaChevronDown className="faq-arrow" />
                                        ) : (
                                            <FaChevronRight className="faq-arrow" />
                                        )}
                                    </button>

                                    {blogOpen && (
                                        <ul className="faq-submenu">
                                            {/* Blog List */}
                                            <li>
                                                <button
                                                    onClick={() => handleTabChange('/blog')}
                                                    className={
                                                        location.pathname === '/blog' ||
                                                            location.pathname === '/blogadd' ||
                                                            location.pathname.startsWith('/blogedit') ||
                                                            location.pathname.startsWith('/blogview')
                                                            ? 'active'
                                                            : ''
                                                    }
                                                >
                                                    Blog List
                                                </button>
                                            </li>

                                            {/* Blog Tag */}
                                            <li>
                                                <button
                                                    onClick={() => handleTabChange('/blogtag')}
                                                    className={
                                                        location.pathname === '/blogtag' ||
                                                            location.pathname === '/blogtagadd'
                                                            ? 'active'
                                                            : ''
                                                    }
                                                >
                                                    Blog Tag
                                                </button>
                                            </li>
                                        </ul>
                                    )}
                                </li>

                                {/* Home */}
                                <li>
                                    <button
                                        onClick={() => handleTabChange('/homepage')}
                                        className={startsWith('/homepage') || startsWith('/testimonialedit')
                                            || startsWith('/testimonialvideoadd') || startsWith('/testimonialvideoedit')
                                            || startsWith('/testimonialreviewadd') || startsWith('/testimonialreviewedit') || startsWith('/VisaHomeEdit') ? 'active' : ''}
                                    >
                                        <img src={homeIcon} alt="Home" className="sidebar-icon" />
                                        Home
                                    </button>
                                </li>

                                {/* About */}
                                <li>
                                    <button
                                        onClick={() => handleTabChange('/aboutus')}
                                        className={startsWith('/aboutus') || startsWith('/aboutusedit') || startsWith('/aboutbanneredit') || startsWith('/founderedit') || startsWith('/ourstoryedit') || startsWith('/ourmissionedit') ? 'active' : ''}
                                    >
                                        <img src={aboutIcon} alt="Aboutus" className="sidebar-icon" />
                                        About
                                    </button>
                                </li>

                                {/* Services */}
                                <li>
                                    <button
                                        onClick={() => handleTabChange('/services')}
                                        className={startsWith('/services') || startsWith('/ourservices') || startsWith('/banneredit') || startsWith('/howitworkedit') || startsWith('/whychooseusedit') || startsWith('/ourgalleryedit') ? 'active' : ''}
                                    >
                                        <img src={servicesIcon} alt="Services" className="sidebar-icon" />
                                        Services
                                    </button>
                                </li>

                                {/* Contact */}
                                <li>
                                    <button
                                        onClick={() => handleTabChange('/contactus')}
                                        className={location.pathname === '/contactus' || startsWith('/editsocial') || startsWith('/editcontact') || startsWith('/editmap') || startsWith('/editasra') ? 'active' : ''}
                                    >
                                        <img src={contactIcon} alt="Contact" className="sidebar-icon" />
                                        Contact Us
                                    </button>
                                </li>


                                {/* Contact us form */}
                                <li>
                                    <button
                                        onClick={() => handleTabChange('/contactusform')}
                                        className={location.pathname === '/contactusform' || startsWith('/contactusformview') ? 'active' : ''}
                                    >
                                        <img src={contactIcon} alt="Contactusform" className="sidebar-icon" />
                                        Contact Us Form
                                    </button>
                                </li>


                                {/* Eligibility */}
                                <li>
                                    <button
                                        onClick={() => {
                                            sessionStorage.removeItem("consultationLanguageId");
                                            setEligibilityOpen(prev => !prev);
                                        }}
                                        className={`faq-main-btn ${startsWith('/eligibility') || startsWith('/eligibilitylabel') || startsWith('/eligibilitycandidate') ? 'active' : ''
                                            }`}
                                    >
                                        <img src={eligibilityIcon} alt="Eligibility" className="sidebar-icon" />
                                        Eligibility
                                        {eligibilityOpen ? (
                                            <FaChevronDown className="faq-arrow" />
                                        ) : (
                                            <FaChevronRight className="faq-arrow" />
                                        )}
                                    </button>

                                    {eligibilityOpen && (
                                        <ul className="faq-submenu">
                                            <li>
                                                <button
                                                    onClick={() => handleTabChange('/eligibility')}
                                                    className={
                                                        startsWith('/eligibility') && !startsWith('/eligibilitylabel') && !startsWith('/eligibilitycandidate')
                                                            ? 'active'
                                                            : ''
                                                    }
                                                >
                                                    Eligibility Form
                                                </button>
                                            </li>


                                            <li>
                                                <button
                                                    onClick={() => handleTabChange('/eligibilitylabel')}
                                                    className={startsWith('/eligibilitylabel') ? 'active' : ''}
                                                >
                                                    Eligibility Points
                                                </button>
                                            </li>
                                            <li>
                                                <button
                                                    onClick={() => handleTabChange('/eligibilitycandidate')}
                                                    className={startsWith('/eligibilitycandidate') ? 'active' : ''}
                                                >
                                                    Eligible Candidates
                                                </button>
                                            </li>
                                        </ul>
                                    )}
                                </li>
                                {/* Consultation OLD Data*/}
                                <li>
                                    <button
                                        onClick={() => {
                                            sessionStorage.removeItem("consultationLanguageId");
                                            setOldConsultationOpen(prev => !prev);
                                        }}
                                        className={`faq-main-btn ${startsWith('/OldConsultation') ||
                                            startsWith('/OldConsultationFromList') ||
                                            startsWith('/Oldcalender')
                                            ? 'active'
                                            : ''
                                            }`}
                                    >
                                        <img src={consultationIcon} alt="Consultation" className="sidebar-icon" />
                                        Consultation Old Data
                                        {oldconsultationOpen ? <FaChevronDown className="faq-arrow" /> : <FaChevronRight className="faq-arrow" />}
                                    </button>

                                    {oldconsultationOpen && (
                                        <ul className="faq-submenu">
                                            <li>
                                                <button
                                                    onClick={() => handleTabChange('/OldConsultationFromList')}
                                                    className={startsWith('/OldConsultationFromList') || startsWith('/OldConsultationEdit') ? 'active' : ''}
                                                >
                                                    Consultation Old List
                                                </button>
                                            </li>

                                            <li>
                                                <button onClick={() => handleTabChange('/Oldcalender')} className={startsWith('/Oldcalender') ? 'active' : ''}>Consultation Old Calender</button>
                                            </li>
                                        </ul>
                                    )}
                                </li>
                                {/* Consultation (NO CLEARING HERE ❗) */}
                                <li>
                                    <button
                                        onClick={() => {
                                            sessionStorage.removeItem("consultationLanguageId");
                                            setConsultationOpen(prev => !prev);
                                        }}
                                        className={`faq-main-btn ${startsWith('/Consultation') ||
                                            startsWith('/ConsultationFromList') ||
                                            startsWith('/IntakeFormEdit') ||
                                            startsWith('/PrimaryInfo') ||
                                            startsWith('/calender') ||
                                            startsWith('/consultationtimeslot') ||
                                            startsWith('/bookingconfirmation') ||
                                            startsWith('/paymentrequest')
                                            ? 'active'
                                            : ''
                                            }`}
                                    >
                                        <img src={consultationIcon} alt="Consultation" className="sidebar-icon" />
                                        Consultation
                                        {consultationOpen ? <FaChevronDown className="faq-arrow" /> : <FaChevronRight className="faq-arrow" />}
                                    </button>

                                    {consultationOpen && (
                                        <ul className="faq-submenu">
                                            <li>
                                                <button
                                                    onClick={() => handleTabChange('/Consultation')}
                                                    className={
                                                        (
                                                            startsWith('/Consultation') ||
                                                            startsWith('/ConsultationEditBooking') ||
                                                            startsWith('/IntakeFormEdit')
                                                        ) &&
                                                            !startsWith('/ConsultationFromList') &&
                                                            !startsWith('/ConsultationFromView') &&
                                                            !startsWith('/ConsultationEdit')

                                                            ? 'active'
                                                            : ''
                                                    }
                                                >
                                                    Consultation Form
                                                </button>
                                            </li>
                                            <li>
                                                <button
                                                    onClick={() => handleTabChange('/PrimaryInfo')}
                                                    className={startsWith('/PrimaryInfo') ? 'active' : ''}
                                                >
                                                    Primary Info
                                                </button>
                                            </li>
                                            <li>
                                                <button
                                                    onClick={() => handleTabChange('/ConsultationFromList')}
                                                    className={startsWith('/ConsultationFromList') || startsWith('/ConsultationFromView') || startsWith('/ConsultationEdit') ? 'active' : ''}
                                                >
                                                    Consultation List
                                                </button>
                                            </li>

                                            <li>
                                                <button onClick={() => handleTabChange('/calender')} className={startsWith('/calender') ? 'active' : ''}>Consultation Calender</button>
                                            </li>


                                            <li>
                                                <button
                                                    onClick={() => handleTabChange('/consultationtimeslot')}
                                                    className={startsWith('/consultationtimeslot') ? 'active' : ''}
                                                >
                                                    Consultation Time Slot
                                                </button>
                                            </li>


                                            {/* <li>
                                                <button
                                                    onClick={() => navigate('/paymentrequest')}
                                                    className={startsWith('/paymentrequest') ? 'active' : ''}
                                                >
                                                    Payment Request
                                                </button>
                                            </li> */}



                                            {/* <li>
                                                <button
                                                    onClick={() => navigate('/bookingconfirmation')}
                                                    className={startsWith('/bookingconfirmation') ? 'active' : ''}
                                                >
                                                    Booking Confirmation
                                                </button>
                                            </li> */}






                                        </ul>
                                    )}
                                </li>

                                {/* Settings */}
                                <li>
                                    {/* <button
                                    // onClick={() => navigate('/settings')}
                                    // className={startsWith('/settings') ? 'active' : ''}
                                    >
                                        <img src={settingIcon} alt="Settings" className="sidebar-icon" />
                                        Settings
                                    </button> */}
                                </li>
                            </ul>
                        </div>
                    </nav>
                </div>
            </aside>
        </div>
    );
};

export default Sidebar;
